




















































































































import {
  defineComponent, reactive, computed, ref,
} from '@vue/composition-api';
import { useRouter } from '@ideavivat/vivat-2';

import PanelWithCopyEntity from '@/components/PanelWithCopyEntity.vue';

import CommonHandicraftGroupSelector from '@/components/Selector/CommonHandicraftGroupSelector.vue';
import CommonHandicraftTypeSelector from '@/components/Selector/CommonHandicraftTypeSelector.vue';
import CommonYearSelector from '@/components/Selector/CommonYearSelector.vue';
import CommonFavoriteFilterSelector from '@/components/Selector/CommonFavoriteFilterSelector.vue';
import CommonConfirmDialog from '@/components/Dialog/CommonConfirmDialog.vue';
import CommonFavoriteButton from '@/components/CommonCustomButton/CommonFavoriteButton.vue';
import { ToggleButton } from 'vue-js-toggle-button';

import getTotalFavoriteHandicraft from '@/gql/getTotalFavoriteHandicraft.gql';
import handicraft from '@/table/handicraft';
import getHandicrafts from '@/gql/getHandicrafts.gql';
import getHandicraftTypes from '@/gql/getHandicraftTypes.gql';
import setFavoriteHandicraft from '@/gql/setFavoriteHandicraft.gql';
import setAcitveHandicraft from '@/gql/setActiveHandicraft.gql';
import deleteHandicraft from '@/gql/deleteHandicraft.gql';
import { useQuery, useResult, useMutation } from '@vue/apollo-composable';

import cdn from '@/cdn';
import i18n from '@/i18n';

const List = defineComponent({
  setup() {
    const { result: totalFavoriteHandicraftResult } = useQuery(getTotalFavoriteHandicraft);
    const totalFavoriteHandicraft = useResult(totalFavoriteHandicraftResult, 0, (data) => data.handicrafts.paginatorInfo);
    const warningFavorite = ref(null);

    const getHandicraftsResult = (data: any) => data.handicrafts;
    /* ==== Get Handicraft Type ==== */
    const { result: handicraftTypeResult } = useQuery(getHandicraftTypes);
    const handicraftTypes = useResult(handicraftTypeResult, {}, (data) => data.handicraftTypes);

    // ==== Mutate Favorite Item ==== //
    const changeFavorite = reactive({
      id: undefined,
      status: false,
    });

    const favoriteMutation = useMutation(
      setFavoriteHandicraft,
      () => ({
        variables: {
          ...changeFavorite,
        },
        refetchQueries: ['getHandicrafts', 'getTotalFavoriteHandicraft'],
      }),
    );

    function favoriteStar(id: any, status: boolean) {
      if (!status && totalFavoriteHandicraft.value.total >= 30) (warningFavorite.value as any).open();
      else {
        changeFavorite.id = id;
        changeFavorite.status = !status;
        favoriteMutation.mutate();
      }
    }
    // ============================= //

    // ==== Variables for search ==== //
    const search = reactive({
      text: '',
      groupOfWork: '',
      year: '',
      typeOfWork: '',
      fav: 'any',
    });

    // ==== Mutate Active Item ==== //
    const changeActive = reactive({
      id: undefined,
      status: false,
    });

    const activeMutation = useMutation(
      setAcitveHandicraft,
      () => ({
        variables: {
          ...changeActive,
        },
        refetchQueries: ['getHandicrafts'],
      }),
    );

    function setActiveStatus(id: any, status: boolean) {
      changeActive.id = id;
      changeActive.status = status;
      activeMutation.mutate();
    }
    // ============================= //

    // ==== Set message to display on delete dialog ==== //
    const deleteItem = reactive({
      id: '',
      name: '',
    });
    function setDisplayItem(item: any) {
      deleteItem.id = item.id;
      deleteItem.name = item.name;
    }
    // ==== Create delete Mutation ==== //
    const deleteMutation = useMutation(
      deleteHandicraft,
      () => ({
        variables: {
          id: deleteItem.id,
        },
        refetchQueries: ['getHandicrafts'],
      }),
    );

    // ==== Redirect to view item page ==== //
    const { router } = useRouter();
    function viewItem(item: any) {
      router.push({ name: 'HandicraftView', params: { handicraftId: item.item?.id } });
    }

    // ==== Use to search Handicraft ==== //
    const handicraftListVariables = computed(() => {
      const vars: {[key: string]: any} = {
        filterCreatedYear: undefined,
        filterHandicraftGroup: undefined,
        filterHandicraftType: undefined,
        searchNameOrDisplayId: undefined,
        filterFavorite: undefined,
      };
      if (search.text) {
        vars.searchNameOrDisplayId = {
          OR: [
            { column: 'name', operator: 'LIKE', value: `%${search.text}%` },
            { column: 'displayId', operator: 'LIKE', value: `%${search.text}%` },
          ],
        };
      }
      if (search.groupOfWork) {
        vars.filterHandicraftGroup = search.groupOfWork;
      }
      if (search.typeOfWork) {
        vars.filterHandicraftType = search.typeOfWork;
      }
      if (search.year) {
        vars.filterCreatedYear = parseInt(search.year, 10) - 543;
      }
      if (search.fav) {
        vars.filterFavorite = search.fav === 'any' ? undefined : search.fav === 'true';
      }
      return vars;
    });

    const copyingItem = ref({});

    return {
      copyingItem,
      warningFavorite,
      handicraftsQuery: getHandicrafts,
      handicraftTableOption: handicraft,
      getHandicraftsResult,
      handicraftTypes,
      search,
      favoriteStar,
      setActiveStatus,
      deleteItem,
      setDisplayItem,
      deleteMutation,
      viewItem,
      handicraftListVariables,
      cdnAccess: cdn.access,
      i18n,
    };
  },
  components: {
    PanelWithCopyEntity,
    CommonHandicraftTypeSelector,
    CommonHandicraftGroupSelector,
    CommonYearSelector,
    CommonFavoriteFilterSelector,
    CommonFavoriteButton,
    CommonConfirmDialog,
    ToggleButton,
  },
  props: {
    role: {},
  },
});

export default List;
